import { render, staticRenderFns } from "./claimDesc.vue?vue&type=template&id=b5fcc44a&scoped=true"
import script from "./claimDesc.vue?vue&type=script&lang=js"
export * from "./claimDesc.vue?vue&type=script&lang=js"
import style0 from "./claimDesc.vue?vue&type=style&index=0&id=b5fcc44a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fcc44a",
  null
  
)

export default component.exports